import { DecoratorNode } from "lexical";
import React from "react";
import { AudioInputNodeComp } from "./Comp";
import { nanoid } from "nanoid";

export class AudioInputNode extends DecoratorNode {

  static getType() {
    return "AudioInputNode";
  }

  static clone(node) {
    return new AudioInputNode({
      value: node.__value,
      files: node.__files,
      id: node.__id,
      key: node.__key,
    });
  }

  static importJSON(serializedNode) {
    return $createAudioInputNode({
      value: serializedNode.value,
      id: serializedNode.id,
    });
  }

  exportJSON() {
    return {
      type: this.constructor.getType(),
      value: this.__value,
      id: this.__id,
    };
  }

  constructor({ value, files, id, key }) {
    super(key);
    this.__value = value;
    this.__files = files;
    this.__id = id || nanoid(6);
  }

  createDOM() {
    return document.createElement("div");
  }

  updateDOM() {
    return false;
  }

  onChange(editor, value) {
    editor.update(() => {
      const self = this.getWritable();
      self.__value = value;
      if (self.__files) {
        self.__files = undefined;
      }
    });
  }

  onRemove(editor) {
    editor.update(() => {
      this.remove();
    });
  }

  decorate(editor, editorConfig) {
    return (
      <AudioInputNodeComp
        nodeKey={this.__key}
        id={this.__id}
        files={this.__files}
        value={this.__value}
        onChange={(k, v) => this.onChange(editor, v)}
        onRemove={() => this.onRemove(editor)}
        readOnly={editorConfig.theme.RTE_COMP_PROPS.readOnly}
      />
    );
  }

  isInline(){ //somehow this is important so that if this block is at end of editor, and we do arrow down + enter, then a new line will be created. Else it will not.
    return false
  }

}

export function $createAudioInputNode({ value, files, id, key }) {
  return new AudioInputNode({ value, files, id, key });
}

export function $isAudioInputNode(node) {
  return node instanceof AudioInputNode;
}
